<template>
  <modal
    title="Select Timezone"
    :visible="show"
    show-ok
    can-close
    @close="$emit('close')"
    @submit="handleSubmit"
  >
    <template v-slot:body>
      <search-select
        :options="timezonesList"
        :value="selectedTimezone"
        @error="handleError"
        @change="handleChanging"
      />
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/dialog/Modal.vue";
import SearchSelect from "@/components/timezone/SearchSelect.vue";

/** shortcuts locking utils */
import { lockShortcuts, unlockShortcuts } from "@/utils/shortcuts.js";

import { mapActions, mapState } from "vuex";

// @group Dialog
// Modal tha allow to select channel timezone
export default {
  name: "TimezoneSelectModal",
  components: {
    Modal,
    SearchSelect
  },
  props: {
    // is modal shown
    show: {
      type: Boolean,
      default: false
    },
    channelId: {
      type: String,
    }
  },
  data() {
    return {
      selectedTimezone: this.timezone,
      isError: false
    };
  },
  computed: {
    ...mapState({
      timezone: state => state.timezone.timezone,
      timezonesList: state => state.timezone.timezonesList
    })
  },
  watch: {
    // @vuese
    // Synchronize local selected timezone with external property
    timezone() {
      this.selectedTimezone = this.timezone;
    },
    // @vuese
    // Lock shortcuts when modal is opened
    show() {
      if (this.show) {
        lockShortcuts();
      } else {
        unlockShortcuts();
      }
    }
  },
  methods: {
    ...mapActions("timezone", ["selectTimezone"]),
    // @vuese
    // Set error state
    handleError() {
      this.isError = true;
    },
    // @vuese
    // Update timezone and reset error
    // @arg newTz - new timezone
    handleChanging(newTz) {
      this.isError = false;
      this.selectedTimezone = newTz;
    },
    // @vuese
    // Try to update timezone
    handleSubmit() {
      if (this.isError) {
        return;
      }

      this.selectTimezone({timezone: this.selectedTimezone, channelId: this.channelId});
      this.$emit("close");
    }
  }
};
</script>

<style>
.timezone-modal {
  width: 400px;
}
.timezone-select input {
  background-color: #333;
}
</style>
